export enum WebsiteWidgetLayout {
    Vertical = 'vertical',
    Horizontal = 'horizontal'
}

export interface IWebsiteWidgetConfig {
    layout: WebsiteWidgetLayout;
    nhid: number;
    showReviewScore?: boolean;
    showRatings?: boolean;
    showWriteReviewButton?: boolean;
    widthFull?: boolean;
    width?: number;
    reviewCount?: number;
    showLogo?: boolean;
    backgroundColor?: string;
    showFacilityName?: boolean;
    showReviews?: boolean;
    showReadAllReviewsLink: boolean;
    slideShow?: boolean;
    slideShowReviewsCount?: number;
    minReviewRating?: number;
    showDate?: boolean;
    showReviewSnippet?: boolean;
    showReviewerAndConnection?: boolean;
    border?: boolean;
    noFollowLinks?: boolean;
    marginTop?: number;
    marginBottom?: number;
    marginLeft?: number;
    marginRight?: number;
}
